/* eslint-disable react/prop-types */
import { GetRequest } from "@/lib/http";
import { History, UserX } from "lucide-react";
import React, { useEffect, useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { airtelLogo, etisalatLogo, gloLogo, mtnLogo } from "@/assets";
import { FaUsersSlash } from "react-icons/fa6";
import { useMediaQuery } from "react-responsive";
import { cn } from "@/lib/utils";

const DataBeneficiaries = ({ setValue, telcos }) => {
  const [beneficiariesData, setBeneficiariesData] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 380px)" });

  const fetchBeneficiary = async () => {
    const { data, err } = await GetRequest({
      url: "/api/beneficiary?type=phone",
      setState: setLoading,
      errorMessage: "Error fetching beneficiaries",
    });

    if (!err) {
      // Filter only phone beneficiaries
      const phoneBeneficiaries = data.filter((item) => item.type === "phone");
      setBeneficiariesData(phoneBeneficiaries);
    } else {
      console.log(err);
    }
  };

  const getProviderLogo = (item) => {
    const network = item.network?.toLowerCase();
    if (network?.includes("mtn")) return mtnLogo;
    if (network?.includes("airtel")) return airtelLogo;
    if (network?.includes("glo")) return gloLogo;
    if (network?.includes("9mobile")) return etisalatLogo;
    return null;
  };

  useEffect(() => {
    fetchBeneficiary();
  }, []);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="bg-primary cursor-pointer rounded-sm p-1 text-xs font-semibold text-white"
        role="button"
        type="button"
      >
        Beneficiaries
      </button>
      <Sheet open={isOpen} onOpenChange={setOpen}>
        <SheetContent>
          <SheetHeader>
            <SheetTitle>Select Beneficiary</SheetTitle>
            <SheetDescription>
              Choose a beneficiary to purchase data for
            </SheetDescription>
          </SheetHeader>

          <div className="-mt-4 px-2">
            {loading ? (
              <div className="dark:border-darkBorder dark:bg-darkBg flex flex-col items-center justify-center gap-2 rounded-xl border bg-gray-50 p-4 py-7">
                <div className="bg-primary flex size-16 items-center justify-center rounded-full">
                  <History size={30} className="animate-spin text-white" />
                </div>
              </div>
            ) : beneficiariesData.length > 0 ? (
              <div
                className={cn(
                  "no-scrollbar mx-2 grid gap-4 overflow-y-auto md:grid-cols-3",
                  isMobile ? "grid-cols-2" : "grid-cols-2",
                )}
              >
                {beneficiariesData
                  .sort(
                    (a, b) => new Date(b.updated_at) - new Date(a.updated_at),
                  )
                  .map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        const telco = telcos.find((value) =>
                          item.network?.toLowerCase()?.includes(value),
                        );
                        setValue("carrier", telco);
                        setValue("phone", item.value);
                        setValue("saveBeneficiary", false);
                        setOpen(false);
                      }}
                      className="group hover:border-primary hover:dark:border-primary col-span-1 flex cursor-pointer flex-col items-center gap-2 rounded-xl border p-3 transition-colors duration-200 ease-in-out hover:border-2 dark:border-gray-500"
                    >
                      <img
                        src={getProviderLogo(item)}
                        alt="provider-logo"
                        className="size-10 rounded-full"
                      />
                      <h3 className="text-center text-xs font-medium transition-colors duration-200 ease-in-out group-hover:text-black group-hover:dark:text-white">
                        {item?.name}
                      </h3>
                    </div>
                  ))}
              </div>
            ) : (
              <div className="dark:border-darkBorder dark:bg-darkBg mx-2 flex flex-col items-center justify-center gap-3 rounded-xl border bg-gray-50 py-4">
                <div className="bg-primary flex size-14 items-center justify-center rounded-full">
                  <FaUsersSlash size={27} className="text-white" />
                </div>
                <p className="text-center font-medium text-gray-500 dark:text-gray-200">
                  No beneficiaries found
                </p>
              </div>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default DataBeneficiaries;
